import { OrgSpacePage } from '@hq/org-admin';
import { hq } from '../session';

/**
 * 楼宇与楼层（平台侧跨租户，门禁 sys:org:manage）。
 * 页面实现收敛在 `@hq/org-admin`，本端开启租户维度（先选租户再选机构）。
 */
export default function OrgSpace() {
  return <OrgSpacePage platform hq={hq} />;
}
